import * as React from "react";
import withStyles, {
  WithStyles,
  ClassNameMap,
} from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles";
import { StyleRules } from "@material-ui/core/styles/withStyles";
import { AppBar } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { IconButton, Tooltip } from "@material-ui/core";

import MenuDrawer from "./menu-drawer";
import UserPrefsButton from "~common/components/app-view/user-prefs-button";
import FloatingTrigger from "~common/components/floating-trigger";
import { Hidden } from "@material-ui/core";
import { Avatar } from "@material-ui/core";
import { Chip } from "@material-ui/core";

import PortalUserContext from "~common/lib/portal-user-context";
import Faq from "~common/lib/models/faq";
// import helpDocumentButton from '../help-document-button';
import { MuiThemeProvider } from "@material-ui/core/styles";

import ErrorBoundary from "~common/components/error-boundary";

import HomeButton from "~common/components/home";
import {
  theme,
  styleRules,
  logoFileName,
} from "~common/components/app-view/theme";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import * as request from "superagent";

var Mousetrap = require("mousetrap");

const styles = (theme: Theme): StyleRules => styleRules;

Mousetrap.prototype.stopCallback = function (e, element) {
  e.preventDefault();
  return false;
};

const ExpireDialog = (props) => {
  const { title, children, open, onConfirm } = props;
  return (
    <Dialog open={open} aria-labelledby="confirm-dialog">
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent style={{width: 450}}>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            onConfirm();
          }}
          color="primary"
        >
          Extend
        </Button>
      </DialogActions>
    </Dialog>
  );
};

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  areaKey: string;
  hideToolbar?: boolean;
  helpDocUrl?: string;
  isTokenUser?: boolean;
}

type State = {
  drawerOpen: boolean;
  anchorEl?: HTMLElement;
  helpDocUrl?: string | undefined;
  isExpiring: boolean;
  timeRemaining: any;
  sessionExpireTime: Date;
  ExpireInterval: any;
  ExpireTimeout: any;
};

class AppView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
  }

  state = {
    anchorEl: undefined,
    drawerOpen: false,
    helpDocUrl: this.props.helpDocUrl,
    isExpiring: false,
    timeRemaining: 0,
    sessionExpireTime: undefined,
    ExpireInterval: undefined,
    ExpireTimeout: undefined,
  };

  componentDidMount() {
    const { areaKey, helpDocUrl } = this.props;
    Mousetrap.bind("ctrl+alt+h", () => {
      window.location.href = "/";
    });

    window.setInterval(() => {
      var x = (window as any).cookieStore.getAll();
      x.then(this.checkExpiration);
    }, 1000 * 5);
  }

  getWarningThresholdMinutes = () => {
    var m = 2
    if (
      (window as any).App &&
      (window as any).App.browserEnvironment &&
      (window as any).App.browserEnvironment.BROWSER_PORTAL_USER_SESSION_EXPIRE_ALERT_WAIT_MINUTES 
    ) {
      m = Number((window as any).App.browserEnvironment.BROWSER_PORTAL_USER_SESSION_EXPIRE_ALERT_WAIT_MINUTES);
    }

    return m
  }

  getWarningThresholdMessage = () => {
    var msg:string = "Your session is about to expire.";
    if (
      (window as any).App &&
      (window as any).App.browserEnvironment &&
      (window as any).App.browserEnvironment.BROWSER_PORTAL_USER_SESSION_EXPIRE_ALERT_MESSAGE 
    ) {
      msg = (window as any).App.browserEnvironment.BROWSER_PORTAL_USER_SESSION_EXPIRE_ALERT_MESSAGE;
    }

    return msg;
  }

  checkExpiration = (cookieStores: any) => {
    if (
      (window as any).App &&
      (window as any).App.browserEnvironment &&
      ((window as any).App.browserEnvironment
        .BROWSER_PORTAL_USER_SESSION_RESET_ON_ACTIVE == "true" ||
        (window as any).App.browserEnvironment
          .BROWSER_PORTAL_USER_SESSION_EXPIRE_SHOW_TIMER == "true")
    ) {
      var expiring: boolean = false;
      const { isExpiring } = this.state;
      let expireAt: Date;
      if ((window as any).App && (window as any).App.userContext) {
        cookieStores.forEach((c) => {
          if (c.name == "portalExpire") {
            expiring = new Date(new Date().getTime() + this.getWarningThresholdMinutes() * 60000) > c.expires;
            if (expiring) {
              expireAt = new Date(
                new Date(new Date().getTime() + this.getWarningThresholdMinutes() * 60000).getTime()
              );
              this.setState({
                ExpireInterval: (window as any).setInterval(() => {
                  this.setState({});
                }, this.getWarningThresholdMinutes() * 1000),
              });
            } else {
              this.cancelExpiration(false);
            }
          }
        });
      }

      if (!isExpiring && expiring) {
        this.setState(
          {
            isExpiring: true,
            sessionExpireTime: expireAt,
            ExpireInterval: (window as any).setInterval(() => {
              this.setState({});
            }, this.getWarningThresholdMinutes() * 1000),
          },
          () => {
            this.setState({
              ExpireTimeout: (window as any).setTimeout(() => {
                const { isExpiring } = this.state;
                if (isExpiring) {
                  window.location.href = "/logout";
                }
              }, (this.getWarningThresholdMinutes() * 1000) * 60),
            });
          }
        );
      }
    }
  };

  doCancelExpire = () => {
    this.cancelExpiration(true);
  };
  cancelExpiration = (doPost: boolean) => {
    const { ExpireInterval, ExpireTimeout } = this.state;
    if (doPost) {
      request.get("/session/extend").then((response) => {});
    }
    if (this.state.isExpiring) {
      clearTimeout(ExpireTimeout);
      clearInterval(ExpireInterval);
      this.setState({ isExpiring: false });
    }
  };

  handleLogin = (event: any) => {
    // const path = '/login';
    // This was not working in all cases
    //this.props.history.push(path);
    //window.open(path);
    window.location.href = "/login";
  };

  handleDrawerMenu = (event: any) => {
    this.setState({ drawerOpen: true });
  };

  handleDrawerMenuClose = () => {
    this.setState({ drawerOpen: false });
  };

  render() {
    const { history, areaKey, isTokenUser } = this.props;
    const { classes }: { classes: ClassNameMap } = this.props;
    const { drawerOpen, helpDocUrl, isExpiring, sessionExpireTime } =
      this.state;

    const isLoggedIn = PortalUserContext.isLoggedIn();
    const showLoginButton = !isLoggedIn && window.location.pathname != "/login";

    let floatingHelpTrigger;
    if (helpDocUrl) {
      floatingHelpTrigger = (
        <FloatingTrigger faIconClass="fas fa-life-ring" url={helpDocUrl} />
      );
    }

    let floatingSuggestionTrigger;
    if (areaKey) {
      let right = 15;
      if (floatingHelpTrigger != null) {
        right = 90;
      }
      floatingSuggestionTrigger = (
        <FloatingTrigger
          faIconClass="fas fa-lightbulb"
          url={"/suggestions" + "/" + areaKey}
          right={right}
        />
      );
    }

    let bottomPadding;
    if (floatingHelpTrigger || floatingSuggestionTrigger) {
      bottomPadding = <div className={classes.bottomPadding} />;
    }
    let countdown = null;
    let expiredModal = null;
    if (isExpiring) {
      if (
        (window as any).App &&
        (window as any).App.browserEnvironment &&
        (window as any).App.browserEnvironment.BROWSER_PORTAL_USER_SESSION_UI ==
          "dialog" &&
        isExpiring
      ) {
        expiredModal = (
          <ExpireDialog
            title="WARNING"
            open={isExpiring}
            setOpen={null}
            onConfirm={() => {
              this.setState(
                {
                  isExpiring: false,
                },
                () => {
                  request.get("/session/extend").then((response) => {
                    console.log("Extended");
                  });
                }
              );
            }}
          >
            {this.getWarningThresholdMessage()}
          </ExpireDialog>
        );
      } else {
        countdown = (
          <span>
            <Chip
              avatar={
                <i
                  style={{
                    fontSize: 20,
                    color:
                      Math.floor(
                        (sessionExpireTime - (new Date() as any)) / 1000
                      ) > 60
                        ? "yellow"
                        : "red",
                    paddingLeft: 10,
                    paddingTop: 3,
                  }}
                  className="fa fa-lightbulb"
                />
              }
              onClick={this.doCancelExpire}
              label={this.getWarningThresholdMessage()}
            />
          </span>
        );
      }
    }
    let sizer;
    if (window.location.hostname === "localhost" && isLoggedIn) {
      sizer = (
        <span>
          <Hidden only={["sm", "md", "lg", "xl"]}>
            <Chip
              avatar={<Avatar>XS</Avatar>}
              label="Extra Small"
              className={classes.chip}
            />
          </Hidden>
          <Hidden only={["xs", "md", "lg", "xl"]}>
            <Chip
              avatar={<Avatar>SM</Avatar>}
              label="Small"
              className={classes.chip}
            />
          </Hidden>
          <Hidden only={["xs", "sm", "lg", "xl"]}>
            <Chip
              avatar={<Avatar>MD</Avatar>}
              label="Medium"
              className={classes.chip}
            />
          </Hidden>
          <Hidden only={["xs", "sm", "md", "xl"]}>
            <Chip
              avatar={<Avatar>LG</Avatar>}
              label="Large "
              className={classes.chip}
            />
          </Hidden>
          <Hidden only={["xs", "sm", "md", "lg"]}>
            <Chip
              avatar={<Avatar>XL</Avatar>}
              label="Extra Large"
              className={classes.chip}
            />
          </Hidden>
        </span>
      );
    }

    return (
      <ErrorBoundary>
        <MuiThemeProvider theme={theme}>
          <div className={classes.root}>
            <MenuDrawer
              open={drawerOpen}
              onClose={this.handleDrawerMenuClose}
              history={history}
            />
            <AppBar position="fixed" className="appBar">
              <Toolbar className={classes.toolbar}>
                {isLoggedIn && !isTokenUser && (
                  <IconButton
                    color="inherit"
                    onClick={this.handleDrawerMenu}
                    className={classes.menuButton + "  menu-toggle "}
                    aria-label="Menu"
                  >
                    <i className="fas fa-bars"></i>
                  </IconButton>
                )}
                <img className={classes.logo} src={logoFileName} />
                <Typography variant="h6" className={classes.appTitle}>
                  {
                    "" // TODO: jdouglas - Add functionality for portal setting on logo and title
                  }
                </Typography>
                {countdown}
                {sizer}
                {showLoginButton && (
                  <Button
                    className={classes.appBarButton}
                    color="inherit"
                    onClick={this.handleLogin}
                  >
                    Login
                  </Button>
                )}
                {isLoggedIn && !isTokenUser && (
                  <Tooltip enterDelay={500} title="Ctrl+Alt+H">
                    <span className={classes.homeIcon}>
                      <HomeButton classes={classes} color="inherit" />
                    </span>
                  </Tooltip>
                )}
                {isLoggedIn && !isTokenUser && (
                  <div>
                    <UserPrefsButton
                      classes={classes}
                      color="inherit"
                      history={history}
                    />
                  </div>
                )}
              </Toolbar>
            </AppBar>
            {this.props.children}
            {floatingHelpTrigger}
            {expiredModal}
            {/* {floatingSuggestionTrigger} */}
            {bottomPadding}
          </div>
        </MuiThemeProvider>
      </ErrorBoundary>
    );
  }
}

export default withStyles(styles)<any>(AppView);
